'use strict';

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var React = require('react');
var TitleSection = require('./common/title-section');
var BodySection = require('./common/body-section');
var CTASection = require('./common/cta-section');

module.exports = React.createClass({
    displayName: 'Free Esignature Tool SEO Page',

    renderTitleSection: function renderTitleSection() {
        var titleSectionProps = {
            title: 'Free eSignature Tool',
            subtitle: 'It\'s simple to start signing for free! Create your HelloSign account and start signing.',
            buttonText: 'SIGN ME UP!'
        };
        return React.createElement(TitleSection, _extends({}, titleSectionProps, this.props));
    },

    renderBodySection: function renderBodySection() {
        var headerClass = 'm-marketing-page--header';
        var listClass = 'm-marketing-page--list';
        return _jsx(BodySection, {}, void 0, _jsx('h2', {
            className: headerClass
        }, void 0, 'What is HelloSign?'), _jsx('p', {}, void 0, 'HelloSign is a desktop and device-friendly app allows you to complete paperwork online. Our technology is compliant with current eSignature laws and our bank-level security ensures a secure way to sign your paperwork online. We’ve been around since 2010 and have been growing fast over the past few years!'), _jsx('h2', {
            className: headerClass
        }, void 0, 'How many free documents do I get per month with HelloSign?'), _jsx('p', {}, void 0, 'You get 3 free documents per month when you sign up for the free HelloSign plan. Your account is automatically refilled each month. Unused documents don’t rollover .'), _jsx('h2', {
            className: headerClass
        }, void 0, 'What’s included in the next plan up?'), _jsx('p', {}, void 0, 'Any Pro plan or above includes unlimited documents and access to HelloSign templates. You’ll also have access to ', _jsx('a', {
            href: 'https://www.hellosign.com/info/demo-data-validation',
            target: '_blank'
        }, void 0, 'data validation'), ', a tool that helps you to prevent signer error by setting rules for your text fields. There are also plans for teams for cross-team document tracking and to make sure everyone on your team is always sending out the latest version.'), _jsx('p', {}, void 0, 'You can learn more about the plans by ', _jsx('a', {
            href: 'https://www.hellosign.com/info/pricing',
            target: '_blank'
        }, void 0, 'visiting the pricing plan here.')), _jsx('h2', {
            className: headerClass
        }, void 0, 'Is it legal to sign documents online using HelloSign?'), _jsx('p', {}, void 0, 'Yes! It’s legal to sign documents online using HelloSign’s free eSignature tool. In fact, it’s also a more secure way to keep track of your documents. Audit trails are attached to each document giving you a clear look at the journey of your doc. Audit trails log each time a person interacts with a document and timestamps these events.'), _jsx('h2', {
            className: headerClass
        }, void 0, 'How do I sign documents online?'), _jsx('p', {}, void 0, 'It’s easy to start signing with HelloSign! You can create a free account by linking your Google login or entering in your email here. Once you’ve created your free account, you’re ready to start sending. Simply upload the document you’d like signed, format it using signature or text fields, and send the signature request! You can also upload documents sent to you that require a signature and insert your own signature.'));
    },

    renderCTASection: function renderCTASection() {
        var ctaSectionProps = {
            title: 'Get Started',
            subtitle: 'Whatcha waiting for? Let’s get you signing!',
            signupButtonText: 'CREATE A HELLOSIGN ACCOUNT',
            signupButtonUrl: this.props.homeUrl,
            secondButtonText: 'SEE PRO PLANS',
            secondButtonUrl: this.props.pricingUrl
        };
        return React.createElement(CTASection, _extends({}, ctaSectionProps, this.props));
    },

    render: function render() {
        return _jsx('div', {}, void 0, this.renderTitleSection(), this.renderBodySection(), this.renderCTASection());
    }
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/components/free-esignature-tool.jsx
 ** module id = 822
 ** module chunks = 0
 **/